import {SlSelect} from '@shoelace-style/shoelace/shoelace';
import {notNull} from '../../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert';
import {ReloadManager} from '../reloadManager';
import {ScrollToElement} from '../../common/scrollToElement';

export class Angebotslist {
    private readonly viewRoot: HTMLElement;
    private readonly reloadManager: ReloadManager;

    constructor(viewRoot: HTMLElement) {
        this.reloadManager = new ReloadManager();
        this.viewRoot = viewRoot;
        this.changeTarifartEventListeners();
        this.changeArticleEventListeners();
        this.submitListeners();
        this.closeFilterMobile();
    }

    private changeTarifartEventListeners() {
        const cmsReloadModuleTarifart = this.viewRoot.querySelectorAll<HTMLInputElement>('input.cmsReloadModuleTarifart');
        cmsReloadModuleTarifart.forEach((element) => {
            element.addEventListener('change', (event) => {
                const container = element.closest('div.vtart');
                if (!container) {
                    return;
                }
                const checked = element.checked;
                const inputs = container.querySelectorAll<HTMLInputElement>('input.cmsReloadModuleTarifart');

                inputs.forEach((input) => {
                    input.checked = false;
                });

                element.checked = checked;
                this.reloadManager.cmsReloadModule(event);
            });
        });
    }

    private changeArticleEventListeners() {
        const selects = this.viewRoot.querySelectorAll<SlSelect>('sl-select.cmsReloadModule');
        selects.forEach((select) => {
            select.addEventListener('sl-change', (event) => {
                const target = event.target as SlSelect;
                const cmsRoot = target.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }
                const hiddenField = cmsRoot.querySelector<HTMLInputElement>('#hidden_' + target.name);
                if (!hiddenField) {
                    return;
                }
                hiddenField.value = target.value as string;

                this.reloadManager.cmsReloadModule(event);
            });
        });
    }

    /**
     * nur fuer die sortieren funktion
     */
    private submitListeners() {
        const submitForms = this.viewRoot.querySelectorAll<HTMLFormElement>('form.moduleCms_offerlist');

        submitForms.forEach((element: HTMLFormElement) => {
            element.addEventListener('submit', (event: SubmitEvent) => {
                event.preventDefault();
                this.reloadManager.reloadModule(element, true);
            });
        });
    }
    private closeFilterMobile() {
        // geht zu wenn man auf der close-icon oder auf die ganze filterzeile klickt
        const closeFilterButtons = this.viewRoot.querySelectorAll<HTMLAnchorElement>(
            'form.moduleCms_offerlist .filter-mobile-headline, ' + 'form.moduleCms_offerlist .closeFilter',
        );
        closeFilterButtons.forEach((element) => {
            element.addEventListener('click', (event: MouseEvent) => {
                event.preventDefault();
                notNull(document.querySelector('body')).classList.remove('no-scroll');
                notNull(document.querySelector('html')).classList.remove('no-scroll');

                const cmsRoot = element.closest('.cms-module-root');
                if (!cmsRoot) {
                    return;
                }

                const filter = cmsRoot.querySelector<HTMLElement>('.cms-tarif-list-filter');
                if (!filter) {
                    return;
                }

                filter.style.display = 'none';
                const row = filter.closest<HTMLElement>('.row');
                if (row) {
                    new ScrollToElement(row);
                }
                event.stopImmediatePropagation();
            });
        });
    }
}
